<template>
	<div>
		<v-text-field
			class="mt-4 no-line"
			label="企業共通情報"
			outlined
			dense
			v-if="customer_company_share_info.name"
			v-model="customer_company_share_info.name"
			readonly
			persistent-hint
			hint="右のアイコンから編集・削除が可能です"
			><template v-slot:append-outer>
				<v-btn icon class="ml-2" @click="dialog = true"><v-icon>mdi-pencil</v-icon></v-btn>
				<v-btn icon class="ml-2" @click="deleteCustomerCompanyShareInfo"><v-icon>mdi-delete</v-icon></v-btn>
			</template></v-text-field
		>
		<v-btn v-else color="secondary" @click="dialog = true"><v-icon class="mr-1">mdi-plus</v-icon>企業共通情報を登録する</v-btn>
		<v-dialog
			v-model="dialog"
			max-width="700px"
			:fullscreen="$vuetify.breakpoint.xs ? true : false"
			:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
		>
			<v-card :tile="$vuetify.breakpoint.xs">
				<v-app-bar dense dark flat color="primary" tag="div">
					<v-app-bar-title class="color-white">企業情報登録</v-app-bar-title>
					<v-spacer />
					<v-btn icon dark @click="dialog = false" color="white">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-app-bar>

				<v-form class="pa-2" ref="form" v-model="valid">
					<v-text-field
						label="顧客企業名(必須)"
						v-model="customerCompanyShareInfo.name"
						dense
						outlined
						:rules="[rules.required]"
						class="mt-4"
						hint=""
					/>
					<div class="mt-4">
						<label class="text-body-2 font-weight-bold">創業年月日</label>
						<v-row class="mt-4" no-gutters>
							<v-col class="pr-1" sm="4">
								<v-combobox v-model="year" dense outlined :items="years" @change="changeEstablishmentDate">
									<template v-slot:append-outer>年</template>
								</v-combobox>
							</v-col>
							<v-col class="px-1" sm="4">
								<v-combobox v-model="month" dense outlined :items="months" @change="changeEstablishmentDate">
									<template v-slot:append-outer>月</template>
								</v-combobox>
							</v-col>
							<v-col class="pl-1" sm="4">
								<v-combobox v-model="day" dense outlined :items="days" @change="changeEstablishmentDate">
									<template v-slot:append-outer>日</template>
								</v-combobox>
							</v-col>
						</v-row>
					</div>
					<v-text-field
						label="資本金"
						v-model="customerCompanyShareInfo.capital"
						dense
						outlined
						class="mt-4"
						:rules="[rules.integer]"
						hide-spin-buttons
						suffix="円"
						hint="半角正数のみ使用可能です。"
					/>
					<v-text-field
						label="従業員数"
						v-model="customerCompanyShareInfo.employees_number"
						dense
						outlined
						class="mt-4"
						:rules="[rules.integer]"
						hide-spin-buttons
						suffix="人"
						hint="半角正数のみ使用可能です。"
					/>
					<v-text-field label="代表者名" v-model="customerCompanyShareInfo.representative" dense outlined class="mt-4" hint="" />
					<v-text-field label="代表者名（カナ）" v-model="customerCompanyShareInfo.representative_kana" dense outlined class="mt-4" hint="" />
					<v-text-field label="Webサイト" v-model="customerCompanyShareInfo.website" dense outlined class="mt-4" hint="" />
				</v-form>
				<p class="pa-2 text-body-2 red--text">登録ボタンを押すまで変更は反映されません。</p>
				<v-card-actions>
					<v-row no-gutters class="pb-2">
						<v-col sm="4" cols="0" />
						<v-col sm="4" cols="12">
							<v-row no-gutters justify="center">
								<v-btn color="secondary" @click="saveForm" :disabled="!valid">
									<v-icon class="mr-2">mdi-plus</v-icon>
									登録する
								</v-btn>
							</v-row>
						</v-col>
						<v-col sm="4" cols="0" v-if="!$vuetify.breakpoint.xs">
							<v-row no-gutters justify="end">
								<v-btn color="grey darken-1" text @click="dialog = false"> 閉じる </v-btn>
							</v-row>
						</v-col>
					</v-row>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import rules from "../../../helper/rules"
import _ from "lodash"

export default {
	props: {
		customer_company_share_info: {
			type: Object,
			required: true,
			default: () => ({}),
		},
	},
	data() {
		return {
			dialog: false,
			valid: false,
			rules: rules,
			customerCompanyShareInfo: {
				name: null,
				capital: null,
				establishment_date: null,
				employees_number: null,
				representative: null,
				representative_kana: null,
				website: null,
			},
			year: null,
			month: null,
			day: null,
		}
	},
	methods: {
		saveForm() {
			this.$emit("update:customer_company_share_info", _.cloneDeep(this.customerCompanyShareInfo))
			this.dialog = false
		},
		deleteCustomerCompanyShareInfo() {
			this.$refs.form.reset()
			this.$emit("update:customer_company_share_info", _.cloneDeep(this.customerCompanyShareInfo))
		},
		changeEstablishmentDate() {
			if (!this.year || !this.month && !this.day) return (this.customerCompanyShareInfo.establishment_date = null)
			this.customerCompanyShareInfo.establishment_date = `${this.year}-${this.month}-${this.day}`
		},
	},
	computed: {
		years() {
			const thisYear = new Date().getFullYear()
			const endYear = 1900
			const years = [...Array(thisYear - endYear + 1)].map((_, i) => thisYear - i)
			return years
		},
		months() {
			const months = [...Array(12)].map((_, i) => i + 1)
			return months
		},
		days() {
			const days = [...Array(31)].map((_, i) => i + 1)
			return days
		},
	},
	watch: {
		customer_company_share_info(newVal) {
			this.customerCompanyShareInfo = _.cloneDeep(newVal)
		},
		deep: true,
	},
}
</script>